<template>

    <!-- example to call this
          <show-more-less-repeater-component :initial-record-count-to-show="5"
                                               :full-data-set="fullListOfTypeOfVisitsFromData">
                <template v-slot:body="row">
                    <div class="mt-2 custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :id="'future-app-filter-typeofvisit-visit-' + row.props" :value="row.props" v-model="selectedFilterData.typeOfVisit">
                        <label class="custom-control-label appt-filter-option-label" :for="'future-app-filter-typeofvisit-visit-' + row.props">{{row.props}}</label>
                    </div>
                </template>

                <template v-slot:seeMoreButtonContainer>
                    See More
                    <i class="ml-2 fas fa-plus"></i>
                </template>

                <template v-slot:seeLessButtonContainer>
                    See Less
                    <i class="ml-2 fas fa-minus"></i>
                </template>

            </show-more-less-repeater-component>
        -->

    <div>
        <div class="row">
            <div class="col">
                <div class="form-group">

                    <div v-for="rowToOutput in topXAmountOfRows">
                        <slot name="body" v-bind:props="rowToOutput">
                        </slot>
                    </div>

                    <div v-if="hasShowMoreRows" class="collapse" :id="uniqueComponentId">
                        <div v-for="restOfTheRows in restOfTheAdditionalRows">
                            <slot name="body" v-bind:props="restOfTheRows">
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="hasShowMoreRows" class="row">

            <div class="col">
                <a data-toggle="collapse" :href="uniqueComponentIdWithAnchor" role="button" aria-expanded="false" :aria-controls="uniqueComponentId">
                    <div class="show-on-collapsed">
                        <slot name="seeMoreButtonContainer">
                        </slot>
                    </div>
                    <div class="show-on-expanded">
                        <slot name="seeLessButtonContainer">
                        </slot>
                    </div>
                </a>
            </div>
        </div>
    </div>

</template>

<script>

    import jlinq from '@SharedServices/linq.javascript.service.js';

    export default {
        name: 'show-more-less-repeater',
        props: {
            initialRecordCountToShow: { type: Number },
            fullDataSet: { type: Array },
        },
        computed: {

            uniqueComponentId: function () {
                return 'show-more-less-repeater' + this._uid;
            },

            uniqueComponentIdWithAnchor: function () {
                return '#' + this.uniqueComponentId;
            },

            topXAmountOfRows: function () {
                return this.fullDataSet
                    .Take(this.initialRecordCountToShow)
                    .ToArray();
            },

            restOfTheAdditionalRows: function () {
                return this.fullDataSet
                    .Skip(this.initialRecordCountToShow)
                    .ToArray();
            },

            hasShowMoreRows: function () {
                return this.restOfTheAdditionalRows.length > 0;
            }
        }
    };

</script>

